export const blockIconsSocialiOSShare = (
	<span className='material-symbols-outlined'>ios_share</span>
);
